import { Injectable } from '@angular/core';

declare var System: any;
@Injectable()
export class ComponentResolver {

    public ResolvedComponents: Map<string, any> = new Map<string, any>();
    private static _modulesArray: Array<any> = [];


    constructor() {


    }

    static forRoot(modulesArray: Array<any>) {

        this._modulesArray = modulesArray;
        console.log(this._modulesArray);
    }

    static getModule() {
        return this._modulesArray;
    }

}